import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import { BUTEURS } from '../data/js/buteurs'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    menu: ['news', 'awards', 'gallery', 'works', 'about', 'contact'],
    // baseURL: 'http://localhost/myprojects/restapi_ridi_website/',
    // buteurs: BUTEURS,
  },
  getters: {
    getButeurs: state => {
      return state.buteurs
    },
    getCalendrier: state => {
      return state.calendrier
    },
    getEquipes: state => {
      return state.equipes
    },
    getJoueurs: state => {
      return state.joueurs
    },
    getStaff: state => {
      return state.staff
    },
/*
    getBaseURL: state => {
      return state.baseURL;
    }
*/
  },
  mutations: {},
  actions: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js